import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, Building2, Users, Search, Sparkles, Settings, LogOut, Command,
  Briefcase, CreditCard, FileSignature, MessageSquare, Inbox, Clock, Ticket, UserCog, Lightbulb,
} from "lucide-react";

const NAV = [
  { to: "/app", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/app/leads", label: "Leads", icon: Inbox },
  { to: "/app/advisory", label: "Advisory Inquiries", icon: Lightbulb },
  { to: "/app/recruiter-waitlist", label: "Recruiter Waitlist", icon: Clock },
  { to: "/app/organizations", label: "Organizations", icon: Building2 },
  { to: "/app/searches", label: "Searches", icon: Search },
  { to: "/app/candidates", label: "Candidates", icon: Users },
  { to: "/app/invites", label: "Invites", icon: Ticket },
  { to: "/app/jobs", label: "Jobs", icon: Briefcase },
  { to: "/app/communications", label: "Communications", icon: MessageSquare },
  { to: "/app/contracts", label: "Contracts", icon: FileSignature },
  { to: "/app/billing", label: "Billing", icon: CreditCard },
  { to: "/app/ai", label: "AI Workspace", icon: Sparkles },
  { to: "/app/users", label: "Users", icon: UserCog },
  { to: "/app/settings", label: "Settings", icon: Settings },
];

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <aside className="w-60 shrink-0 border-r border-black/10 flex flex-col fixed h-screen bg-white z-20">
        <div className="h-16 flex items-center gap-2 px-5 border-b border-black/10">
          <div className="h-7 w-7 bg-primary flex items-center justify-center">
            <Command className="h-4 w-4 text-[#09090B]" strokeWidth={2} />
          </div>
          <div className="leading-tight">
            <p className="font-heading font-black text-sm tracking-tight">INNOVATION</p>
            <p className="overline text-[0.55rem] leading-none">Talent Partners</p>
          </div>
        </div>
        <nav className="flex-1 py-4 flex flex-col gap-0.5 px-3 overflow-y-auto">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-colors duration-150 ${
                  isActive
                    ? "bg-[#09090B] text-white"
                    : "text-muted-foreground hover:text-[#09090B] hover:bg-black/5"
                }`
              }
            >
              <item.icon className="h-4 w-4" strokeWidth={1.5} />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-black/10 p-3">
          <div className="px-2 py-2 mb-1">
            <p className="text-sm font-medium truncate">{user?.full_name}</p>
            <p className="overline text-[0.55rem]">{user?.role}</p>
          </div>
          <button
            onClick={handleLogout}
            data-testid="logout-btn"
            className="flex items-center gap-3 px-3 py-2.5 text-sm w-full text-muted-foreground hover:text-[#09090B] hover:bg-black/5 transition-colors duration-150"
          >
            <LogOut className="h-4 w-4" strokeWidth={1.5} />
            Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-60 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
